// extracted by mini-css-extract-plugin
module.exports = {"ExpandLink":"text-read-more-less_ExpandLink__k4QZs"};